module.exports = __webpack_public_path__ + "img/img_tag_xin.9c9ec716.svg";